import { render, staticRenderFns } from "./custom-server.vue?vue&type=template&id=3d094a5c&scoped=true&"
import script from "./custom-server.vue?vue&type=script&lang=js&"
export * from "./custom-server.vue?vue&type=script&lang=js&"
import style0 from "./custom-server.vue?vue&type=style&index=0&id=3d094a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d094a5c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VChip,VIcon,VSnackbar,VTextField})
